// Customer footer card explaining what happens after add-to-cart +
// care instructions. Sets expectations on turnaround (~2 weeks),
// machine embroidery (not hand), and how the proof workflow runs.

export function WorkflowFooter() {
  return (
    <section className="rk-pc-workflow">
      <h3 className="rk-pc-workflow__title">What happens next?</h3>
      <ol className="rk-pc-workflow__steps">
        <li>
          <span className="rk-pc-workflow__step-num">1</span>
          <div>
            <strong>Order placed.</strong> Your design enters our queue
            within minutes.
          </div>
        </li>
        <li>
          <span className="rk-pc-workflow__step-num">2</span>
          <div>
            <strong>Proof emailed</strong> (if you picked approve-before-
            stitching). One click to approve or request a tweak.
          </div>
        </li>
        <li>
          <span className="rk-pc-workflow__step-num">3</span>
          <div>
            <strong>Stitched</strong> on our 13 industrial machines in our
            Melbourne studio.
          </div>
        </li>
        <li>
          <span className="rk-pc-workflow__step-num">4</span>
          <div>
            <strong>Shipped in about 2 weeks</strong> from order. We email
            tracking the moment it goes out.
          </div>
        </li>
      </ol>
      <div className="rk-pc-workflow__care">
        <strong>Care:</strong> Machine wash cold inside-out, no bleach,
        line dry. Iron on the reverse around (never on top of) the
        stitching.
      </div>
    </section>
  );
}
